import z from 'zod'

export const moduleConfigSchema = z.object({
  name: z.string(),
  isEnabled: z.boolean(),
  metadata: z.record(z.string(), z.string().or(z.boolean())).nullable(),
})

export const moduleConfigListSchema = z.array(moduleConfigSchema)

export type ModuleConfig = z.infer<typeof moduleConfigSchema>
export type ModuleConfigList = z.infer<typeof moduleConfigListSchema>
